import { DayName } from 'generated/graphql';

export const DAYS = [
  {
    day: DayName.Mon,
    label: 'M',
  },
  {
    day: DayName.Tue,
    label: 'T',
  },
  {
    day: DayName.Wed,
    label: 'W',
  },
  {
    day: DayName.Thu,
    label: 'T',
  },
  {
    day: DayName.Fri,
    label: 'F',
  },
  {
    day: DayName.Sat,
    label: 'S',
  },
  {
    day: DayName.Sun,
    label: 'S',
  },
] as const;

export const DAYS_EXCLUDING_WEEKENDS = [
  DayName.Mon,
  DayName.Tue,
  DayName.Wed,
  DayName.Thu,
  DayName.Fri,
];

export const DAYS_INCLUDING_WEEKENDS = [
  ...DAYS_EXCLUDING_WEEKENDS,
  DayName.Sat,
  DayName.Sun,
];

export const DAY_INDEX_MAP = {
  [DayName.Sun]: 0,
  [DayName.Mon]: 1,
  [DayName.Tue]: 2,
  [DayName.Wed]: 3,
  [DayName.Thu]: 4,
  [DayName.Fri]: 5,
  [DayName.Sat]: 6,
  [DayName.Invalid]: 0,
} as const;
